import React from "react";
import { Check, Loader2 } from "lucide-react";

const STAGES = [
  { key: "uploading", label: "Uploading Document" },
  { key: "extracting", label: "Extracting Text" },
  { key: "analysing", label: "Analysing Case" },
  { key: "generating", label: "Generating Summary" },
  { key: "ready", label: "Ready for Review" },
];

export default function AIStepper({ stage, error, onRetry }) {
  const activeIndex = STAGES.findIndex((s) => s.key === stage);
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-lg p-6" data-testid="ai-stepper">
      <div className="label-eyebrow text-npst-gold mb-4">AI Document Processing</div>
      <div className="space-y-3">
        {STAGES.map((s, i) => {
          const done = activeIndex > i || stage === "ready" && i <= activeIndex;
          const current = activeIndex === i && stage !== "ready";
          const isReady = stage === "ready";
          const complete = done || (isReady);
          return (
            <div key={s.key} className="flex items-center gap-3">
              <div className={`w-7 h-7 rounded-full flex items-center justify-center border ${complete && !current ? "bg-emerald-500 border-emerald-500 text-white" : current ? "bg-blue-500 border-blue-500 text-white" : "bg-white border-slate-300 text-slate-300"}`}>
                {current ? <Loader2 size={14} className="animate-spin" /> : complete && !current ? <Check size={14} /> : <span className="text-xs">{i + 1}</span>}
              </div>
              <span className={`text-sm font-medium ${current ? "text-blue-700" : complete ? "text-emerald-700" : "text-slate-400"}`}>{s.label}</span>
            </div>
          );
        })}
      </div>
      {error && (
        <div className="mt-4 flex items-center justify-between bg-red-50 border border-red-200 rounded px-4 py-3">
          <span className="text-sm text-red-700">{error}</span>
          {onRetry && <button onClick={onRetry} className="text-sm font-semibold text-red-700 underline" data-testid="ai-retry">Retry</button>}
        </div>
      )}
    </div>
  );
}
